import { getStoryBySlug } from '@cinch-nx/data-storyblok'
import { Env, readFromEnv } from '@cinch-nx/environments'
import { traceFunction } from '@core/datadog-server'
import { GetStaticProps, InferGetStaticPropsType } from 'next'
import { BrandPageStory } from './storyblok/storyblok'
import { GetStaticPropsContext } from 'next'

const isDev = process.env.STAGE_NAME !== 'production'
const STORYBLOK_BFF_URL = readFromEnv(Env.StoryblokBFFComponent)

// Generic function to get story by slug
const getStorySlug = async (preview: boolean, slug: string) =>
  await getStoryBySlug<BrandPageStory>(
    `brands/${slug}`,
    {
      version: preview || isDev ? 'draft' : 'published',
      resolve_relations:
        'CarsCarousel.financeRepresentativeExample,FinanceOffersCarousel.financeRepresentativeExample',
    },
    { strict: true, urlDomain: STORYBLOK_BFF_URL },
  )

const getStorySlugProps = async (slug: string, preview = false) => {
  try {
    const story = await getStorySlug(preview, slug)

    return {
      props: {
        story,
        preview,
        layoutProps: {
          heroProps: story.content.hero[0],
          showBorderRadius: false,
        },
      },
      revalidate: 60,
    }
  } catch {
    return { notFound: true } as const
  }
}
const getStaticPropsfn: GetStaticProps = async ({
  params,
  preview = false,
}: GetStaticPropsContext) =>
  await getStorySlugProps(params?.slug as string, preview)

export const getStaticProps = traceFunction(
  'brandpage.getStaticProps',
  getStaticPropsfn,
)

export type BrandPageProps = InferGetStaticPropsType<typeof getStorySlugProps>
